<template>
  <Teleport to="body">
    <div v-if="modelValue" class="fixed inset-0 z-[80] overflow-y-auto">
      <div class="fixed inset-0 bg-black/50" @click="closeModal"></div>
      <div class="relative min-h-screen p-4">
        <div
          ref="panelRef"
          role="dialog"
          aria-modal="true"
          aria-label="资金申请业务详情"
          tabindex="-1"
          class="relative mx-auto flex max-h-[92vh] w-full max-w-5xl flex-col rounded-2xl bg-white shadow-xl"
        >
          <div class="flex shrink-0 items-center justify-between border-b border-slate-200 px-6 py-4">
            <div>
              <h3 class="text-lg font-semibold text-slate-900">资金申请业务详情</h3>
              <p class="mt-0.5 text-xs text-slate-500">审批中心内查看对应财富资金申请、批次明细和附件。</p>
            </div>
            <button type="button" class="p-1.5 text-slate-400 hover:text-slate-600" @click="closeModal">
              <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <div class="flex-1 overflow-y-auto bg-slate-50 p-5">
            <WealthOperationApplyBusinessDetail
              :apply-id="applyId"
              :approval-instance-id="approvalInstanceId"
            />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, toRef } from 'vue'
import WealthOperationApplyBusinessDetail from './WealthOperationApplyBusinessDetail.vue'
import { useModalA11y } from '@/composables/useModalA11y'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  applyId: {
    type: [Number, String],
    default: null
  },
  approvalInstanceId: {
    type: [Number, String],
    default: null
  }
})

const emit = defineEmits(['update:modelValue'])

const panelRef = ref(null)
useModalA11y(toRef(props, 'modelValue'), panelRef, closeModal)

function closeModal() {
  emit('update:modelValue', false)
}
</script>
